module.exports = __webpack_public_path__ + "back.c469008d.png";